import { defineMessages } from 'react-intl'

import { STORE_TABS } from 'app/utils/constants/status.constants'

const messages = defineMessages({
  products: { defaultMessage: 'Products' },
  reviews: { defaultMessage: 'Reviews' }
})

export const storeTabs = [
  {
    label: messages.products,
    value: STORE_TABS.products
  },
  {
    label: messages.reviews,
    value: STORE_TABS.reviews
  }
]
